import zappy from "@zappy-ride/library.react.components";
import { SmartStepper } from "./SmartStepper";

export * from "./SmartStepper";

zappy.FactoryInstance.registerComponent(SmartStepper);
